<template>
    <b-modal scrollable b-modal ref="mdlSchedeValutazione" id="mdlSchedeValutazione" size="xl" style="height: 100%" :title="titoloModale" @ok="onInvia" @hidden="onHidden" no-close-on-backdrop no-close-on-esc centered>
        <div class="sa-tab-scroll">
            <b-card v-if="modalStep === 0" class="sa-card sa-card-border" header=" " header-tag="header" footer-tag="footer" title="">
                <b-table sticky-header ref="table" stacked="sm" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(actions)="{ item }">
                        <b-container class="bv-example-row">
                            <b-button v-if="item.path !== null && item.path !== ''" size="sm" title="---" variant="outline-success" @click="onNuovaScheda(item)">
                                <font-awesome-icon icon="edit"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </b-card>
            <b-card v-show="modalStep === 1" header-tag="header" footer-tag="footer" title="">
                <component ref="itemRefs" :is="currentComponentEdit" v-bind="currentProperties" @update="onUpdateJsonData"></component>
            </b-card>
        </div>

        <template #modal-footer>
            <b-button v-if="!isModalView" size="md" class="no-text" variant="outline-danger" @click="onClickUndo">Annulla</b-button>
            <b-button v-if="!isModalView" @click="onSalvaRichiesta" :disabled="modalStep !== 1" variant="outline-success">Salva</b-button>
            <b-button v-if="isModalView" @click="onClickOk" variant="outline-primary">Ok</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaSchedaValutazioneAllegatoAEditComponent from "../../components/rsaschedevalutazione/RsaSchedaValutazioneAllegatoAEditComponent.vue";
import RsaSchedaAnamnesiaStoriaClinicaModalEditComponent from "../../components/rsaschedevalutazione/RsaSchedaAnamnesiaStoriaClinicaModalEditComponent.vue";
import RsaSchedaAreaMobilitaModalEditComponent from "../../components/rsaschedevalutazione/RsaSchedaAreaMobilitaModalEditComponent.vue";
import RsaSchedaPsicologicaModalEditComponent from "../../components/rsaschedevalutazione/RsaSchedaPsicologicaModalEditComponent.vue";
import RsaSchedaSocialePazienteModalEditComponent from "../../components/rsaschedevalutazione/RsaSchedaSocialePazienteModalEditComponent.vue";
import RsaSchedaRiferimentiDiagnosticiEditComponent from "../../components/rsaschedevalutazione/RsaSchedaRiferimentiDiagnosticiEditComponent.vue";
import RsaSchedaEsameObiettivoGeneraleModalEditComponent from "../../components/rsaschedevalutazione/RsaSchedaEsameObiettivoGeneraleModalEditComponent.vue";
import RsaSchedaInfermieristicaModalEditComponent from "../../components/rsaschedevalutazione/RsaSchedaInfermieristicaModalEditComponent.vue";
import RsaSchedaRelazioneSanitariaModalEditComponent from "../../components/rsaschedevalutazione/RsaSchedaRelazioneSanitariaModalEditComponent.vue";

export default {
    components: { ModalError, RsaSchedaValutazioneAllegatoAEditComponent, RsaSchedaAnamnesiaStoriaClinicaModalEditComponent, RsaSchedaAreaMobilitaModalEditComponent, RsaSchedaPsicologicaModalEditComponent, RsaSchedaSocialePazienteModalEditComponent, RsaSchedaRiferimentiDiagnosticiEditComponent, RsaSchedaEsameObiettivoGeneraleModalEditComponent, RsaSchedaInfermieristicaModalEditComponent, RsaSchedaRelazioneSanitariaModalEditComponent },
    props: {
        // utente: {
        //     type: Object,
        //     default: function () {
        //         return null;
        //     },
        // },
    },
    data() {
        return {
            idAccettazione: null,
            modalStep: 0,
            sezione: "VALUTAZIONEINGRESSO",
            pathResourceSchedeValutazione: "/rsaschedevalutazione",
            pathResource: null,
            listKey: 1,
            perPage: 50,
            currentPage: 1,
            titoloModale: null,
            isModalView: false,
            gruppoItems: [],
            rigaSelezionata: {},
            jsonData: {},
            filtro: {},
            items: [],
            currentComponentEdit: null,
            currentProperties: {},
            fields: [
                {
                    label: "Tipo Scheda",
                    key: "tipoScheda",
                },
                {
                    label: "",
                    key: "actions",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },

    watch: {
        modalStep: {
            handler() {
                let me = this;
                switch (me.modalStep) {
                    case 0:
                        me.titoloModale = "Selezione Valutazione Ingresso";
                        break;
                    case 1:
                        me.titoloModale = me.isModalView ? "Visualizzazione: " + me.rigaSelezionata.tipoScheda : "Compilazione: " + me.rigaSelezionata.tipoScheda;

                        break;
                }
            },
            immediate: true,
        },
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceSchedeValutazione;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            me.filtro.sezione = me.sezione;
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.items = [];
                    me.items = response.data.data.list;
                    me.rows = response.data.data.recordsNumber;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },

        onNuovaScheda(value) {
            let me = this;
            me.modalStep = 1;
            me.currentProperties = { idAccettazione: me.idAccettazione };
            me.currentComponentEdit = me.getComponent(value.tipoScheda);
            me.rigaSelezionata = value;
            me.pathResource = value.path;
        },
        show(id) {
            let me = this;

            me.modalStep = 0;
            me.listKey++;
            me.idAccettazione = id;
            me.gruppoItems = {};
            me.rigaSelezionata = {};
            me.$refs.mdlSchedeValutazione.show();
            me.loadData();
        },
        visualizzaScheda(item) {
            let me = this;
            me.isModalView = true;
            me.currentComponentEdit = me.getComponent(item.tipoScheda);
            me.modalStep = 1;
            me.currentProperties = { idRisorsa: item.id, idAccettazione: item.idAccettazione, isReadOnly: true };
            me.rigaSelezionata = item;

            me.$refs.mdlSchedeValutazione.show();
        },
        modificaScheda(item) {
            let me = this;
            me.modalStep = 1;
            me.isModalView = false;
            me.currentProperties = { idRisorsa: item.id, idAccettazione: item.idAccettazione, isReadOnly: false };
            me.currentComponentEdit = me.getComponent(item.tipoScheda);
            me.rigaSelezionata = item;
            me.$refs.mdlSchedeValutazione.show();
        },

        /*  */

        getComponent(tipoScheda) {
            let component = null;
            switch (tipoScheda) {
                case "ALLEGATO A":
                    component = RsaSchedaValutazioneAllegatoAEditComponent;
                    break;
                case "ANAMNESI / STORIA CLINICA":
                    component = RsaSchedaAnamnesiaStoriaClinicaModalEditComponent;
                    break;
                case "AREA MOBILITA'":
                    component = RsaSchedaAreaMobilitaModalEditComponent;
                    break;
                case "SCHEDA PSICOLOGICA":
                    component = RsaSchedaPsicologicaModalEditComponent;
                    break;
                case "SCHEDA SOCIALE":
                    component = RsaSchedaSocialePazienteModalEditComponent;
                    break;
                case "RIFERIMENTI DIAGNOSTICI":
                    component = RsaSchedaRiferimentiDiagnosticiEditComponent;
                    break;
                case "ESAME OBIETTIVO GENERALE":
                    component = RsaSchedaEsameObiettivoGeneraleModalEditComponent;
                    break;
                case "SCHEDA INFERMIERISTICA":
                    component = RsaSchedaInfermieristicaModalEditComponent;
                    break;
                case "SCHEDA RELAZIONE SANITARIA":
                    component = RsaSchedaRelazioneSanitariaModalEditComponent;
                    break;
            }
            return component;
        },
        onInvia() {
            let me = this;
            me.modalStep = 0;
        },
        onSalvaRichiesta() {
            let me = this;
            console.log("Clemy prova ", me.jsonData);
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultSaveResponse, me.resultSaveError);
        },
        resultSaveResponse() {
            let me = this;
            me.modalStep = 0;
            me.$emit("afterSave");
            me.$refs.mdlSchedeValutazione.hide();
        },
        resultSaveError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onHidden() {
            let me = this;
            me.isModalView = false;
            me.jsonData = {};
            me.currentComponentEdit = null;
            me.modalStep = 0;
        },
        onClickUndo() {
            let me = this;
            me.jsonData = {};
            me.currentComponentEdit = null;
            if (me.modalStep === 1 && !me.currentProperties.idRisorsa) {
                me.modalStep = 0;
            } else {
                me.$refs.mdlSchedeValutazione.hide();
            }
        },
        onClickOk() {
            let me = this;
            me.$refs.mdlSchedeValutazione.hide();
            me.isModalView = false;
            me.jsonData = {};
            me.modalStep = 0;
            me.currentComponentEdit = null;
        },
    },
};
</script>

<style></style>
